import styled from "styled-components";

const LastArticlesContainer = styled.div`
	/* display: flex; */
`;
export { LastArticlesContainer };
